module.exports = __webpack_public_path__ + "img/style_1_1.d820a7c4.png";